import { render, staticRenderFns } from "./PerformanceTargetsResultsDataTable.vue?vue&type=template&id=0fc394a3"
import script from "./PerformanceTargetsResultsDataTable.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetsResultsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports